export const MIN_DOTS_SIZE = 2;
export const MAX_DOTS_SIZE = 6;
